module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAcklEQVR4Ae3SwQ1AABAF0SkC6FYplABK4qYGSgAAM8ne/0sWM7PPlAHjwsvePP42xHjx7U+AAPtgX3gdAQIECBAgQIAAAQIECBAgYFMCBAjoThzfcUH5iYCCC4qA/oTxPRByUSnQAsMBwwegAlJel5nZBF4SHY3gr0t/AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/Screens/Importconfig/baseline_delete_black_24dp.png
// module id = 156
// module chunks = 0